<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-5 px-7">
    <div class="header">
      <h1 class="title">{{ $t(template.additionTitle) }}</h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideAddition"></p>
    </div>
    <div class="body">
      <v-form ref="form">
        <v-row>
          <v-col
            :cols="
              ['C', 'F'].includes(addition)
                ? '4'
                : addition !== 'A' && addition !== 'D'
                ? '6'
                : '12'
            "
          >
            <v-col class="mt-n4">
              <v-radio-group
                v-model="veterans"
                row
                :rules="[v => !!v || '필수 정보입니다.']"
                @change="
                  onChange(
                    'veteransType',
                    'veteransNumber',
                    'veteransRelation',
                    'veteransGrade',
                  )
                "
                :readonly="isReadonly"
              >
                <span class="col-4 py-0">{{ itemLabel('veteransYn') }}</span>
                <i-radio label="무" value="N" class="col-4 py-0 mr-0"></i-radio>
                <i-radio label="유" value="Y" class="col-4 py-0 mr-0"></i-radio>
              </v-radio-group>
            </v-col>
          </v-col>
          <v-col
            v-if="addition !== 'A' && addition !== 'D'"
            :cols="['C', 'F'].includes(addition) ? '4' : '6'"
          >
            <DirectInputSelect
              v-model="veteransType"
              :items="itemArray('veteransType')"
              v-maxlength="'veterans_type'"
              :label="itemLabel('veteransType')"
              :useDirect="itemDirectInput('veteransType')"
              outlined
              dense
              @change="save"
              :readonly="isReadonly"
              :disabled="veterans === 'N'"
              :rules="veterans === 'N' ? [] : [rules.required('veteransType')]"
            />
            <!-- <i-select
              
            ></i-select> -->
          </v-col>
          <v-col cols="4" v-if="['C', 'F'].includes(addition)">
            <i-text-field
              :label="itemLabel('veteransNumber')"
              v-model="veteransNumber"
              v-maxlength="'veterans_number'"
              outlined
              @blur="save"
              dense
              :readonly="isReadonly"
              :disabled="veterans === 'N'"
              :rules="
                veterans === 'N'
                  ? []
                  : [
                      rules.required('veteransNumber'),
                      rules.maxlength('veteransNumber'),
                    ]
              "
            ></i-text-field>
          </v-col>
        </v-row>
        <v-row v-if="['G', 'H'].includes(addition)">
          <v-col cols="4">
            <i-text-field
              :label="itemLabel('veteransNumber')"
              v-model="veteransNumber"
              v-maxlength="'veterans_number'"
              outlined
              @blur="save"
              dense
              :readonly="isReadonly"
              :disabled="veterans === 'N'"
              :rules="
                veterans === 'N'
                  ? []
                  : [
                      rules.required('veteransNumber'),
                      rules.maxlength('veteransNumber'),
                    ]
              "
            ></i-text-field>
          </v-col>
          <v-col cols="4">
            <DirectInputSelect
              v-model="veteransRelation"
              :items="itemArray('veteransRelation')"
              v-maxlength="'veterans_relation'"
              :label="itemLabel('veteransRelation')"
              :useDirect="itemDirectInput('veteransRelation')"
              outlined
              dense
              @change="save"
              :readonly="isReadonly"
              :disabled="veterans === 'N'"
              :rules="
                veterans === 'N' ? [] : [rules.required('veteransRelation')]
              "
            />
          </v-col>
          <v-col cols="4">
            <DirectInputSelect
              :useDirect="itemDirectInput('veteransGrade')"
              :items="itemArray('veteransGrade')"
              :label="itemLabel('veteransGrade')"
              v-maxlength="'veterans_grade'"
              v-model="veteransGrade"
              outlined
              @blur="save"
              dense
              :readonly="isReadonly"
              :disabled="veterans === 'N'"
              :rules="
                veterans === 'N'
                  ? []
                  : [
                      rules.required('veteransGrade'),
                      rules.maxlength('veteransGrade'),
                    ]
              "
            ></DirectInputSelect>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" :class="colLength">
            <v-col class="mt-n4">
              <v-radio-group
                v-model="impairment"
                row
                :rules="[v => !!v || '필수 정보입니다.']"
                @change="onChange('impairmentType', 'impairmentClass')"
                :readonly="isReadonly"
              >
                <span class="col-4 py-0">{{ itemLabel('impairmentYn') }}</span>
                <i-radio label="무" value="N" class="col-4 py-0 mr-0"></i-radio>
                <i-radio label="유" value="Y" class="col-4 py-0 mr-0"></i-radio>
              </v-radio-group>
            </v-col>
          </v-col>
          <v-col
            v-if="addition !== 'A' && addition !== 'D'"
            cols="12"
            :class="colLength"
          >
            <DirectInputSelect
              :useDirect="itemDirectInput('impairmentType')"
              :items="itemArray('impairmentType')"
              :label="itemLabel('impairmentType')"
              v-maxlength="'impairment_type'"
              v-model="impairmentType"
              outlined
              dense
              @change="save"
              :readonly="isReadonly"
              :disabled="impairment === 'N'"
              :rules="
                impairment === 'N' ? [] : [rules.required('impairmentType')]
              "
            />
          </v-col>
          <v-col
            v-if="
              addition === 'C' ||
                addition === 'F' ||
                addition == 'G' ||
                addition == 'H'
            "
            cols="12"
            :class="colLength"
          >
            <DirectInputSelect
              :useDirect="itemDirectInput('impairmentClass')"
              v-model="impairmentClass"
              :items="itemArray('impairmentClass')"
              :label="itemLabel('impairmentClass')"
              v-maxlength="'impairment_class'"
              outlined
              dense
              @change="save"
              :readonly="isReadonly"
              :disabled="impairment === 'N'"
              :rules="
                impairment === 'N' ? [] : [rules.required('impairmentClass')]
              "
            />
          </v-col>
        </v-row>
        <v-divider
          v-if="
            addition === 'D' ||
              addition === 'E' ||
              addition === 'F' ||
              addition === 'H'
          "
        ></v-divider>
        <v-row
          v-if="
            addition === 'D' ||
              addition === 'E' ||
              addition === 'F' ||
              addition === 'H'
          "
        >
          <v-col cols="12" :class="colLength">
            <v-col class="mt-n4">
              <v-radio-group
                v-model="vulnerable"
                row
                :readonly="isReadonly"
                :rules="[v => !!v || '필수 정보입니다.']"
                @change="onChange('vulnerableType')"
              >
                <span class="col-4 py-0">{{ itemLabel('vulnerableYn') }}</span>
                <i-radio label="무" value="N" class="col-4 py-0 mr-0"></i-radio>
                <i-radio label="유" value="Y" class="col-4 py-0 mr-0"></i-radio>
              </v-radio-group>
            </v-col>
          </v-col>
          <v-col
            v-if="addition !== 'A' && addition !== 'D'"
            cols="12"
            :class="vulnerableCol"
          >
            <DirectInputSelect
              :useDirect="itemDirectInput('vulnerableType')"
              :items="itemArray('vulnerableType')"
              :label="itemLabel('vulnerableType')"
              v-maxlength="'vulnerable_type'"
              v-model="vulnerableType"
              outlined
              dense
              @change="save"
              :readonly="isReadonly"
              :disabled="vulnerable === 'N'"
              :rules="
                vulnerable === 'N' ? [] : [rules.required('vulnerableType')]
              "
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>
<script>
import DirectInputSelect from '@/components/common/DirectInputSelect.vue';
import { resumeType } from '@/const/resumeType';
import { snack } from '@/plugins/dialog/api';
export default {
  components: { DirectInputSelect },
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },

    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    itemDelimeter: '#',
    addition: '',
    veterans: '',
    impairment: '',
    vulnerable: '',
    veteransType: '',
    veteransRelation: '',
    veteransGrade: '',
    impairmentType: '',
    vulnerableType: '',
    veteransNumber: '',
    impairmentClass: '',
    alert: false,
  }),
  computed: {
    colLength: function() {
      return {
        'col-md-12': this.addition === 'A' || this.addition === 'D',
        'col-md-6': this.addition === 'B' || this.addition === 'E',
        'col-md-4':
          this.addition === 'C' ||
          this.addition === 'F' ||
          this.addition === 'G' ||
          this.addition === 'H',
      };
    },
    vulnerableCol: function() {
      return {
        'col-md-6': this.addition === 'B' || this.addition === 'E',
        'col-md-8':
          this.addition === 'C' ||
          this.addition === 'F' ||
          this.addition === 'G' ||
          this.addition === 'H',
      };
    },
  },
  methods: {
    includesItem(itemName) {
      return resumeType.typeAddition[this.addition]?.includes(itemName);
    },

    itemLabel: function(key) {
      var label = this.template[key];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }

      return label;
    },

    setting: function() {
      if (this.template.typeAddition)
        this.addition = this.template.typeAddition;
      this.dataSetting();
    },
    onChange(...args) {
      args.forEach(key => {
        this[key] = '';
      });
      this.save();
    },
    dataSetting: function() {
      if (this.info && this.info.impairment) {
        this.impairment = this.info.impairment.impairmentYn;
        this.impairmentType = this.info.impairment.impairmentType;
        this.impairmentClass = this.info.impairment.impairmentClass;
      }

      if (this.info && this.info.veterans) {
        this.veterans = this.info.veterans.veteransYn;
        this.veteransType = this.info.veterans.veteransType;
        this.veteransNumber = this.info.veterans.veteransNumber;
        this.veteransRelation = this.info.veterans.veteransRelation;
        this.veteransGrade = this.info.veterans.veteransGrade;
      }

      if (this.info && this.info.vulnerable) {
        this.vulnerable = this.info.vulnerable.vulnerableYn;
        this.vulnerableType = this.info.vulnerable.vulnerableType;
      }
    },
    valid: function() {
      return this.$refs.form.validate();
    },
    save: function() {
      const p = {
        impairmentYn:
          this.impairment ||
          (this.impairmentType || this.impairmentClass ? 'Y' : 'N'),
        impairmentType: this.impairmentType,
        impairmentClass: this.impairmentClass,
        vulnerableYn: this.vulnerable || (this.vulnerableType ? 'Y' : 'N'),
        vulnerableType: this.vulnerableType,
        veteransYn:
          this.veterans ||
          (this.veteransType ||
          this.veteransNumber ||
          this.veteransRelation ||
          this.veteransGrade
            ? 'Y'
            : 'N'),
        veteransType: this.veteransType,
        veteransNumber: this.veteransNumber,
        veteransRelation: this.veteransRelation,
        veteransGrade: this.veteransGrade,
      };

      this.$emit(
        'save',
        { ...p, annoId: this.$route.params.annoId },
        'addition',
      );
    },
    savecallback: function(res) {
      if (res.status !== 200) {
        console.log('ADDITION SAVE FAIL');
      } else snack.info(`${this.template.additionTitle}가 저장 되었습니다.`);
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
